var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[(_vm.statusText)?_c('div',{staticClass:"status-text"},[_c('img',{staticClass:"icon-rorate",attrs:{"src":require("@/assets/img/loading.svg")}}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.statusText)+"...")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3500eae8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/aiAssistent/aiAssistentLoading.vue
// module id = null
// module chunks = 